import { render, staticRenderFns } from "./flats-filter.vue?vue&type=template&id=33c0158c"
import script from "./flats-filter.vue?vue&type=script&lang=js"
export * from "./flats-filter.vue?vue&type=script&lang=js"
import style0 from "./flats-filter.vue?vue&type=style&index=0&id=33c0158c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports